<template>
  <div>

    <div class="col-12">
      <div class="card mb-4">


        <div style="text-align: right; ">
            <b-button 
               variant="outline-primary"    
              @click="toggleFullLayout"
             size="sm"
            >
            <feather-icon
            icon="Maximize2Icon"
            size="12"
          />
          
          </b-button>
        </div>

        <div class="card-header">
          <h4 class="card-title">
            <span>{{RelName}}</span>
          </h4>
     
          <b-col v-if="showFiltro ? false : true ">
            <div style="float:right">
              <div class="DivBotaoLadoLado" >
              <b-button variant="danger" @click="$router.push('../Relatorios')">
                   <span>RETORNAR</span>
               </b-button>
              </div>
               
               <div class="DivBotaoLadoLado" >
               <b-button v-b-toggle="'collapse-filtro'" variant="primary" >
                 <span>FILTROS</span>
               </b-button>
               </div>
            </div>
          </b-col>

        </div>

        <b-collapse visible  id="collapse-filtro">
        <div class="card-body">

          <b-row>
            
            <b-col md="12" xl="12" class="mb-1">
             <b-form-group label="Produto:" >

                 <multiselect
                   v-model="CodProd"
                   placeholder="Selecione"
                   label="name"
                   track-by="code"
                   :options="CodProdOption"
                   :multiple="false"
                   :taggable="false"
                   :close-on-select="true"
                   :option-height="50"
                   :show-labels="false"
                 ></multiselect>

             </b-form-group>
           </b-col>



          </b-row>




        <b-row>
            


        <b-col
                md="6"
                xl="12"
                class="mb-1"
              >
              <div class="DivBotaoLadoLado" >
               <b-button
              variant="danger"
              type="button"
              @click="$router.push('../Relatorios')"
            >
              <span>RETORNAR</span>
            </b-button>
              </div>

              <div class="DivBotaoLadoLado" >
            <b-button v-b-toggle="'collapse-filtro'"
              variant="primary"
              type="submit"
              @click="ConsultarRelatorio"
            >
              <span>CONSULTAR</span>
            </b-button>
              </div>
              
          </b-col>


         </b-row>
         
        </div>
        </b-collapse>
        
      </div>
    </div>


      
    <div class="col-12" v-if="TabRelShelfLifeLocalPAPosition >= 0">
            <div class="card mb-4">
              <div class="card-body pb-60" >
                
                
              <div v-if="TabRelShelfLifeLocalPAPosition == 0">
                
                <div id="TabRelShelfLifeLocalPA">

                <h4 class="fw-bolder mb-1">Detalhe</h4>  
                 <b-table
                  striped
                  hover
                  responsive
                  small
                  sticky-header
                  :items="TabRelShelfLifeLocalPA"
                  :fields="visibleFields"
                  table-class = "font-size11"
                  thead-class = "font-size11"
                  thead-tr-class = "font-size11"
                  
                  
                >


                <template #cell(ESTOQUEKG)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(ESTOQUECX)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(ESTOQUEPT)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>


                 <template #cell(ESTOQUEKG_DIP)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(ESTOQUECX_DIP)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(ESTOQUEPT_DIP)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>


                 <template #cell(DTFABRICACAO)="row">
                      {{ TextFormat(row.value,'date') }}
                 </template>

                 <template #cell(DTVAL)="row">
                      {{ TextFormat(row.value,'date') }}
                 </template>
      
                </b-table>
                </div>

                <div class="col-2" style="float:right">
                   <b-form-group
                      label="">
                      <b-form-select
                      v-model="exportarParaSelected"
                      :options="exportarParaOptions"
                      @change="ExportarDoc('TabRelShelfLifeLocalPA','')"
                      >
                      </b-form-select>
                   </b-form-group>
                </div>

                
              </div>
               

             </div>
            </div>
    </div>



  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import VueApexCharts from 'vue-apexcharts'
import 'bootstrap-icons/font/bootstrap-icons.css'
import apiPortalSky from '@/services/apiPortalSky'
import AlertaMsg from '@/customPortal/AlertaMsg.vue'

import Spinner from '@/components/Spinner.vue'
import UtilVUE from '@/customPortal/UtilVUE.vue'

import {
  BFormGroup,
  BRow,
  BCol,
  BButton,
  BTable,
  BFormSelect,
  BFormInput,
  BCollapse,
  BCard,
  VBToggle,
  BFormDatepicker,
} from 'bootstrap-vue'

export default {
  components: {
    VueApexCharts,
    Multiselect,
    BFormGroup,
    BRow,
    BCol,
    BButton,
    BTable,
    BFormSelect,
    BFormInput,
    BCollapse,
    BCard,
    BFormDatepicker,
  },
  directives: { 'b-toggle': VBToggle },
  data() {
    return {
      showFiltro: true,
      FiltroRelatorio: [],
      RelName: '',
      RelRota: '',
      TipoConsulta: '',
      TabRelShelfLifeLocalPA: [],
      TabRelShelfLifeLocalPAfields: [],
      
      CodProd: [],
      CodProdOption: [],
      exportarParaSelected: 'Exporte',
      exportarParaOptions: [
        { value: 'Exporte', text: 'Exporte' },
        { value: 'XLSX', text: 'Excel' },
      ],
      TabRelShelfLifeLocalPAPosition: -1,
    }
  },
  methods: {
    async MostraReport() {
      let notification = ""
      Spinner.StarLoad()
      const usuario = this.$session.get('usuario')
      
      let ParametroJson = ""
      let URLpost = `/Report/MostraReport?CODUSU=${usuario.codusu}&ROTA=${this.RelRota}`
      await apiPortalSky.post(URLpost, ParametroJson).then(response => {
        if (response.status === 200) {
          if (response.data != null) {
            this.RelName = response.data.descricaoRelatorio
          } else {
            notification = AlertaMsg.FormataMsgFiltroSemRetorno()
            AlertaMsg.FormataMsg(notification)
          }
        }
      }).catch(error => {
        notification = AlertaMsg.FormataMsgAPIError(error)
        AlertaMsg.FormataMsg(notification)
      })

      if(notification === '') {
       Spinner.EndLoad()
      }

    },
    async ConsultarOpcoes() {
      let notification = ""
      Spinner.StarLoad()
      const usuario = this.$session.get('usuario')

      if(notification === '') {
       
       let ParametroJson = ""
       let URLpost = `/Opcoes/ConsultaOpcoes?CODUSU=${usuario.codusu}&OPCAO=Produto&ATIVO=S`
       await apiPortalSky.post(URLpost, ParametroJson).then(response => {
         if (response.status === 200) {
           if (response.data.length > 0) {
             this.CodProdOption = response.data
           } else {
             notification = AlertaMsg.FormataMsgFiltroSemRetorno()
             AlertaMsg.FormataMsg(notification)
           }
         }
       }).catch(error => {
         notification = AlertaMsg.FormataMsgAPIError(error)
         AlertaMsg.FormataMsg(notification)
       })
       
       }

       

      if(notification === '') {
       Spinner.EndLoad()
      }

    },
    async ConsultarRelatorio() {
      Spinner.StarLoad()

      //Inicio Dados Base Relatorio
      this.showFiltro = false
      const usuario = this.$session.get('usuario')
      let notification = ""
      this.FiltroRelatorio = []
      //Fim Dados Base Relatorio

      //Inicio Limpa Dados Retorno
      this.TabRelShelfLifeLocalPA = []
      
      // Fim Limpa Dados Retorno
      
      //Inicio Volta Todos Niveis para posição inicial
      this.TabRelShelfLifeLocalPAPosition = 0
      //Fim Volta Todos Niveis para posição inicial


      //Inicio Pega parametros de Parametros
   
      if(this.CodProd != null){
        if(Array.isArray(this.CodProd) == false)
        {
          const Filtro = {
            parametro: 'CODPROD',
            valor: this.CodProd.code,
          }
          this.FiltroRelatorio.push(Filtro)
        }
      }

       const USADOCOMO = {
          parametro: 'USADOCOMO',
          valor: 'V',
        }
        this.FiltroRelatorio.push(USADOCOMO)

        const CODEMP = {
          parametro: 'CODEMP',
          valor: '2',
        }
        this.FiltroRelatorio.push(CODEMP)

      //Fim Pega parametros de Parametros
      

      let ParametroJson = ''
      let URLpost = ''
      

    if(notification === '') {
      ParametroJson = JSON.parse(JSON.stringify(this.FiltroRelatorio))
      URLpost = `/Report/ExecutaRelShelfLocal?CODUSU=${usuario.codusu}&Nivel=NV_PA`
      await apiPortalSky.post(URLpost, ParametroJson).then(response => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            this.TabRelShelfLifeLocalPA = response.data

            this.CustomFields()
             
           
            
          } else {
            notification = AlertaMsg.FormataMsgFiltroSemRetorno()
            AlertaMsg.FormataMsg(notification)
            
          }
        }
      }).catch(error => {
        notification = AlertaMsg.FormataMsgAPIError(error)
        AlertaMsg.FormataMsg(notification)
        
      })

    }



     if(notification === '') {
       Spinner.EndLoad()
     }

    },
    CustomFields() {
      
     
      this.TabRelShelfLifeLocalPAfields = [
       { key: 'GRUPO', label: 'Grupo', visible: true,  sortable: true,tdClass: 'td100' },
       { key: 'CODPROD', label: 'Cód Produto', visible: true, sortable: true,tdClass: 'td100' },
       { key: 'DESCRPROD', label: 'Produto', visible: true, sortable: true,tdClass: 'td300' }, 
       { key: 'CONTROLE', label: 'Lote', visible: true,sortable: true,tdClass: 'td100' },
       { key: 'DESCRLOCAL', label: 'Local', visible: true,sortable: true,tdClass: 'td150' },

       { key: 'ESTOQUEPT', label: 'Estoque (Pt)', visible: true,sortable: true,tdClass: 'td100' },
       { key: 'ESTOQUEKG', label: 'Estoque (Kg)', visible: true,sortable: true,tdClass: 'td100' },
       { key: 'ESTOQUECX', label: 'Estoque (Cx)', visible: true,sortable: true,tdClass: 'td100' },
       { key: 'SHELF', label: 'Shelf %', visible: true,sortable: true,tdClass: 'td100' },


       { key: 'ESTOQUEPT_DIP', label: 'Estoque (Pt) Disponivel', visible: true,sortable: true,tdClass: 'td100' },
       { key: 'ESTOQUEKG_DIP', label: 'Estoque (Kg) Disponivel', visible: true,sortable: true,tdClass: 'td100' },
       { key: 'ESTOQUECX_DIP', label: 'Estoque (Cx) Disponivel', visible: true,sortable: true,tdClass: 'td100' },
       
       { key: 'DTFABRICACAO', label: 'Fabricação', visible: true,sortable: true,tdClass: 'td100' },
       { key: 'DTVAL', label: 'Validade', visible: true,sortable: true,tdClass: 'td100' },
              
      ]
     

      
      
    },
    TextFormat(valor, tipo) {
      return UtilVUE.TextFormat(valor, tipo)
    },
    ExportarDoc (ElementToExport,DocName) {
      let DataExport = ""
      switch (ElementToExport) {
                case 'TabRelShelfLifeLocalPA':
                DataExport = this.TabRelShelfLifeLocalPA
                DocName = 'RelShelfLifeLocalPA'
                break
      }    
      UtilVUE.ExportDoc(this.exportarParaSelected,DocName,ElementToExport,DataExport)
      this.exportarParaSelected = 'Exporte'
      return

    },
    toggleFullLayout() {
      UtilVUE.toggleFullLayout(this.$router, this.$route);
    }
  },
  computed: {
    visibleFields() {
        return this.TabRelShelfLifeLocalPAfields.filter(field => field.visible)
      }
  },
  mounted() {
    if (this.$route.name != null) {
      this.RelRota = this.$route.name
      this.MostraReport()
      this.ConsultarOpcoes()
    }
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
